import React, { useEffect, useState } from 'react';
import UpcomingEvents from '@components/UpcomingEvents';
import SpecialOffersFeed from '../DealPostFeedCard/components/SpecialOffersFeed';

const PostEndFeatures = () => {
  const [randomNumber, setRandomNumber] = useState<number>(0);

  useEffect(() => {
    setRandomNumber(Math.random());
  }, []);

  const renderCorrectComponent = () => {
    if (randomNumber < 0.3) {
      return <SpecialOffersFeed />;
    }

    if (randomNumber < 0.4) {
      return <UpcomingEvents isMobile />;
    }

    return null;
  };

  return renderCorrectComponent();
};

export default PostEndFeatures;
